<template>
  <div class="row" style="margin-top: 20px">
    <div class="col-md-12 text-center">
      <div class>
        <ul class="nav nav-pills justify-content-center" style="margin-bottom:20px">
          <li class="nav-item">
            <a
              class="nav-link"
              style="cursor:pointer"
              v-bind:class="{ active: abaSelecionada=='resumo' }"
              @click="trocarAba('resumo')"
              
            >Resumo</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              style="cursor:pointer"
              v-bind:class="{ active: abaSelecionada=='resumo-evento' }"
              v-if="retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
              @click="trocarAba('resumo-evento')"
              
            >Evento</a>
          </li>
           <li class="nav-item">
            <a
              class="nav-link"
              style="cursor:pointer"
              v-bind:class="{ active: abaSelecionada=='resumo-servidor' }"
              @click="trocarAba('resumo-servidor')"
              v-if="retornaSite() !== 'Stream1x2'"
            >Servidor</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              style="cursor:pointer"
              v-bind:class="{ active: abaSelecionada=='detalhado' }"
              @click="trocarAba('detalhado')"
              
            >Detalhado</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              style="cursor:pointer"
              v-bind:class="{ active: abaSelecionada=='login' }"
              @click="trocarAba('login')"
              
            >Login</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              style="cursor:pointer"
              v-bind:class="{ active: abaSelecionada=='historico' }"
              @click="trocarAba('historico')"
              v-if="retornaSite() !== 'Stream1x2'"
            >Histórico</a>
          </li>
        </ul>
      </div>
      <div v-bind:style="{display: (abaSelecionada=='resumo' ? 'block' : 'none')}" >
        <ListSessaoViewResumo @clicouEvento="clicouEvento" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='resumo-evento' ? 'block' : 'none')}" v-if="isAdmin || isApresentador">
        <ListSessaoViewResumoServidor propView="evento" @clicouEvento="clicouEvento"  />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='resumo-servidor' ? 'block' : 'none')}" v-if="isAdmin || isApresentador">
        <ListSessaoViewResumoServidor propView="servidor" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='detalhado' ? 'block' : 'none')}" >
        <ListSessaoView ref="listSessaoView" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='login' ? 'block' : 'none')}" >
        <ListSessaoLogin ref="listSessaoLogin" />
      </div>
      <div v-bind:style="{display: (abaSelecionada=='historico' ? 'block' : 'none')}" >
        <ListSessaoViewHistorico ref="listSessaoViewHistorico" />
      </div>
    </div>
  </div>
</template>

<script>
import ListSessaoView from "../lists/ListSessaoView";
import ListSessaoViewResumo from "../lists/ListSessaoViewResumo";
import ListSessaoViewResumoServidor from "../lists/ListSessaoViewResumoServidor";
import ListSessaoLogin from "../lists/ListSessaoLogin";
import ListSessaoViewHistorico from "../lists/ListSessaoViewHistorico";

export default {
  name: "SessaoView",
  components: { ListSessaoView, ListSessaoViewResumo, ListSessaoViewResumoServidor, ListSessaoLogin, ListSessaoViewHistorico },
  methods: {
    trocarAba(aba) {
      this.abaSelecionada = aba;

      if(aba == "login")
      {
        this.$refs.listSessaoLogin.carregarItens();
      }

    },
    clicouEvento(id){

      this.abaSelecionada = "detalhado";
      this.$refs.listSessaoView.selecionarEvento(id);
      this.$refs.listSessaoView.carregarItens();
      
    },
    retornaSite()
    {
      return this.$site;
    }
  },
  data: function () {
    return {
      abaSelecionada: "resumo",
      isAdmin:false,
      isApresentador:false,
    };
  },
  async mounted(){

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";
    this.isApresentador = this.$sessao.usuario.tipoUsuario == "Apresentador" && this.$site == "Weddbets";

  }
};
</script>

<style>
</style>